export const getPOPUrl = (route: string, applicationId: string = '') => {
  return route.replace(':applicationId', applicationId);
};
